var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var _controller, _handleVariantUpdate, _handleZoomMediaSelected;
import { Component } from "@theme/component";
import { ThemeEvents, VariantUpdateEvent, ZoomMediaSelectedEvent } from "@theme/events";
class MediaGallery extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _controller, new AbortController());
    /**
     * Handles a variant update event by replacing the current media gallery with a new one.
     *
     * @param {VariantUpdateEvent} event - The variant update event.
     */
    __privateAdd(this, _handleVariantUpdate, (event) => {
      if (this.dataset.staticGallery === "true") return;
      const source = event.detail.data.html;
      if (!source) return;
      const newMediaGallery = source.querySelector("media-gallery");
      if (!newMediaGallery) return;
      this.replaceWith(newMediaGallery);
    });
    /**
     * Handles the 'zoom-media:selected' event.
     * @param {ZoomMediaSelectedEvent} event - The zoom-media:selected event.
     */
    __privateAdd(this, _handleZoomMediaSelected, async (event) => {
      this.slideshow?.select(event.detail.index, void 0, { animate: false });
    });
  }
  connectedCallback() {
    super.connectedCallback();
    const { signal } = __privateGet(this, _controller);
    const target = this.closest(".shopify-section, dialog");
    target?.addEventListener(ThemeEvents.variantUpdate, __privateGet(this, _handleVariantUpdate), { signal });
    this.refs.zoomDialogComponent?.addEventListener(ThemeEvents.zoomMediaSelected, __privateGet(this, _handleZoomMediaSelected), {
      signal
    });
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    __privateGet(this, _controller).abort();
  }
  /**
   * Zooms the media gallery.
   *
   * @param {number} index - The index of the media to zoom.
   * @param {PointerEvent} event - The pointer event.
   */
  zoom(index, event) {
    this.refs.zoomDialogComponent?.open(index, event);
  }
  /**
   * Preloads an image.
   * @param {number} index - The index of the media to preload.
   */
  preloadImage(index) {
    const zoomDialogMedia = this.refs.zoomDialogComponent?.refs.media[index];
    if (!zoomDialogMedia) return;
    this.refs.zoomDialogComponent?.loadHighResolutionImage(zoomDialogMedia);
  }
  get slideshow() {
    return this.refs.slideshow;
  }
  get media() {
    return this.refs.media;
  }
  get presentation() {
    return this.dataset.presentation;
  }
}
_controller = new WeakMap();
_handleVariantUpdate = new WeakMap();
_handleZoomMediaSelected = new WeakMap();
if (!customElements.get("media-gallery")) {
  customElements.define("media-gallery", MediaGallery);
}
export {
  MediaGallery
};
